<template>
  <div class="sub-menu-collection">
    <div class="sub-menu-collection__container">
      <div class="sub-menu-collection__block">
        <div class="sub-menu-collection__items">
          <a
            v-for="(item, i) in getItems"
            :key="i"
            :href="item.href"
            class="sub-menu-collection__item"
            :class="{ 'sub-menu-collection__item_active': item === focusItem }"
            @mouseover="handlerMouseOver(item)"
          >
            <span v-html="item.name"></span>
            <span v-if="item.new" class="sub-menu-collection__new">{{ item.new }}</span>
          </a>
        </div>
        <div class="sub-menu-collection__picture">
          <a :href="focusItem.href">
            <DefImg v-if="focusItem && focusItem.image" :result="focusItem.image" />
          </a>
        </div>
      </div>
      <div class="sub-menu-collection__bottom">
        <DefButtonSecondary :href="allCollections.href">
          {{ allCollections.name }}
        </DefButtonSecondary>
        <!--        <a :href="allCollections.href" class="sub-menu-collection__link">-->
        <!--          <span>{{ allCollections.name }}</span>-->
        <!--          <svg class="sub-menu-collection__icon"><use xlink:href="#svg-arrow-right"></use></svg>-->
        <!--        </a>-->
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import DefImg from '@components/Def/DefImg/DefImg.vue';
import DefButtonSecondary from '@components/Def/DefButtonSecondary/DefButtonSecondary.vue';

export default {
  name: 'SubMenuCollection',
  components: {
    DefButtonSecondary,
    DefImg,
  },
  props: ['result'],
  data() {
    return {
      focusItem: this.result?.items?.[0],
    };
  },
  computed: {
    ...mapState({
      allCollections: ({ results }) => results?.menus?.mainMenu?.collectionsAll,
    }),
    getItems() {
      return this.result?.items?.filter((el) => el.elementCnt !== 0);
    },
  },
  methods: {
    handlerMouseOver(item) {
      this.focusItem = item;
    },
  },
};
</script>

<style lang="scss" scoped>
.sub-menu-collection {
  position: absolute;
  width: 100%;
  left: 0;
  padding-top: 40px;
  z-index: 3;
  background-color: #fff;
  &__container {
    @extend %container;
  }
  &__link {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: rem(14);
    line-height: 100%;
    color: var(--color-dark-grey);
  }
  &__icon {
    display: block;
    width: 14px;
    height: 14px;
    fill: var(--background-dark-grey);
    margin-left: 6px;
  }
  &__block {
    display: grid;
    grid-template-columns: 3fr 1fr;
    padding-bottom: 16px;
  }
  &__items {
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: 1fr 1fr 1fr;
    grid-template-rows: repeat(15, 1fr);
    grid-row-gap: 16px;
    justify-content: flex-start;
    align-items: flex-start;
  }
  &__item {
    font-weight: 600;
    font-size: rem(12);
    letter-spacing: 0.08em;
    text-transform: uppercase;
    line-height: 125%;
    &_active {
      color: var(--color-dark-grey);
    }
  }
  &__bottom {
    display: flex;
    justify-content: center;
    padding-bottom: 32px;
  }
  &__new {
    background-color: #cbe8d7cc;
    margin-left: 12px;
    padding: 2px 4px;
  }
  :deep(.def-button-secondary) {
    @include point-md {
      font-size: 16px;
      font-weight: 600;
      padding: 0 18px;
      text-transform: uppercase;
      height: 44px;
    }
  }
}
</style>
